import IconHandcash from '../components/ConnectWallet/assets/images/handcash-logo.png';

export default {
  // moneybutton: { label: 'Money Button', icon: IconMoneybutton },
  handcash: { label: 'HandCash', icon: IconHandcash },
};
